import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Pagination.css';

// Page numbers with ellipses, e.g. 1 … 4 5 [6] 7 8 … 20
const pageList = (page, totalPages) => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = new Set([1, totalPages, page - 1, page, page + 1]);
    const sorted = [...pages].filter(p => p >= 1 && p <= totalPages).sort((a, b) => a - b);
    const out = [];
    sorted.forEach((p, i) => {
        if (i > 0 && p - sorted[i - 1] > 1) out.push('gap-' + p);
        out.push(p);
    });
    return out;
};

export const paginate = (items, page, pageSize) => items.slice((page - 1) * pageSize, page * pageSize);

const Pagination = ({ page, pageSize = 10, total, onChange, alwaysShow = false }) => {
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    if (!alwaysShow && total <= pageSize) return null;
    const safePage = Math.min(Math.max(page, 1), totalPages);
    const from = total ? (safePage - 1) * pageSize + 1 : 0;
    const to = Math.min(safePage * pageSize, total);

    return (
        <nav className="admin-pagination" aria-label="Pagination">
            <span className="admin-pagination__info">
                Showing {from}–{to} of {total}
                <b>{pageSize} per page</b>
            </span>
            <div className="admin-pagination__pages">
                <button type="button" onClick={() => onChange(safePage - 1)} disabled={safePage === 1} aria-label="Previous page"><ChevronLeft size={16} /></button>
                {pageList(safePage, totalPages).map(p => (typeof p === 'string'
                    ? <span key={p} className="admin-pagination__gap">…</span>
                    : <button key={p} type="button" className={p === safePage ? 'is-active' : ''} onClick={() => onChange(p)} aria-current={p === safePage ? 'page' : undefined}>{p}</button>))}
                <button type="button" onClick={() => onChange(safePage + 1)} disabled={safePage === totalPages} aria-label="Next page"><ChevronRight size={16} /></button>
            </div>
        </nav>
    );
};

export default Pagination;
